<div class="custom-tab-wrapper my-4">
  <div class="custom-tab-buttons">
    <button [ngClass]="{ active: selectedTab === 0 }" (click)="selectedTab = 0">
      Unprocessed
    </button>
  </div>

  <div class="custom-tab-content">
    <ng-container [ngSwitch]="selectedTab">
      <app-unprocessed-termination-date-adoption-date
        *ngSwitchCase="0"
      ></app-unprocessed-termination-date-adoption-date>
    </ng-container>
  </div>
</div>
